<ng-template pTemplate="header">
  <span class="text-xl font-bold">{{ question_title }}</span>
</ng-template>

<div class="grid align-items-center">
  <div class="col md:col-3">
    <input
      pInputText
      type="text"
      class="w-full"
      placeholder="Filtra per nome..."
      #keywordFilter
      (input)="
        dt1.filterGlobal(
          [
            keywordFilter.value,
            brandFilter.value,
            codeSupplierFilter.value,
            codeEanFilter.value,
            partNumberFilter.value,
            selectedCat.value,
            descShortFilter.value,
            codeInternalFilter.value,
          ],
          ''
        )
      " />
  </div>
  <div class="col md:col-3">
    <input
      pInputText
      type="text"
      class="w-full"
      placeholder="Filtra per brand..."
      #brandFilter
      (input)="
        dt1.filterGlobal(
          [
            keywordFilter.value,
            brandFilter.value,
            codeSupplierFilter.value,
            codeEanFilter.value,
            partNumberFilter.value,
            selectedCat.value,
            descShortFilter.value,
            codeInternalFilter.value,
          ],
          ''
        )
      " />
  </div>
  <div class="col md:col-3">
    <input
      pInputText
      type="text"
      class="w-full"
      placeholder="Filtra per codice fornitore..."
      #codeSupplierFilter
      (input)="
        dt1.filterGlobal(
          [
            keywordFilter.value,
            brandFilter.value,
            codeSupplierFilter.value,
            codeEanFilter.value,
            partNumberFilter.value,
            selectedCat.value,
            descShortFilter.value,
            codeInternalFilter.value,
          ],
          ''
        )
      " />
  </div>
  <div class="col md:col-3">
    <input
      pInputText
      type="text"
      class="w-full"
      placeholder="Filtra per codice EAN..."
      #codeEanFilter
      (input)="
        dt1.filterGlobal(
          [
            keywordFilter.value,
            brandFilter.value,
            codeSupplierFilter.value,
            codeEanFilter.value,
            partNumberFilter.value,
            selectedCat.value,
            descShortFilter.value,
            codeInternalFilter.value,
          ],
          ''
        )
      " />
  </div>
  <div class="col md:col-3">
    <input
      pInputText
      type="text"
      class="w-full"
      placeholder="Filtra per part number..."
      #partNumberFilter
      (input)="
        dt1.filterGlobal(
          [
            keywordFilter.value,
            brandFilter.value,
            codeSupplierFilter.value,
            codeEanFilter.value,
            partNumberFilter.value,
            selectedCat.value,
            descShortFilter.value,
            codeInternalFilter.value,
          ],
          ''
        )
      " />
  </div>
  <div class="col md:col-3">
    <app-product-categories-tree
      [frmControl]="selectedCat"
      (selected)="
        dt1.filterGlobal(
          [
            keywordFilter.value,
            brandFilter.value,
            codeSupplierFilter.value,
            codeEanFilter.value,
            partNumberFilter.value,
            selectedCat.value,
            descShortFilter.value,
            codeInternalFilter.value,
          ],
          ''
        )
      "></app-product-categories-tree>
  </div>
  <div class="col md:col-3">
    <input
      pInputText
      type="text"
      class="w-full"
      placeholder="Filtra per descrizione breve..."
      #descShortFilter
      (input)="
        dt1.filterGlobal(
          [
            keywordFilter.value,
            brandFilter.value,
            codeSupplierFilter.value,
            codeEanFilter.value,
            partNumberFilter.value,
            selectedCat.value,
            descShortFilter.value,
            codeInternalFilter.value,
          ],
          ''
        )
      " />
  </div>
  <div class="col md:col-3">
    <input
      pInputText
      type="text"
      class="w-full"
      placeholder="Filtra per codice interno..."
      #codeInternalFilter
      (input)="
        dt1.filterGlobal(
          [
            keywordFilter.value,
            brandFilter.value,
            codeSupplierFilter.value,
            codeEanFilter.value,
            partNumberFilter.value,
            selectedCat.value,
            descShortFilter.value,
            codeInternalFilter.value,
          ],
          ''
        )
      " />
  </div>
  <div class="col">
    <p-button
      styleClass="butt w-full"
      icon="pi pi-filter-slash"
      (click)="clear(dt1)"
      pTooltip="Elimina filtri"
      tooltipPosition="top"></p-button>
  </div>
  <div
    *ngIf="restrict_to_agreement_id"
    class="col-12 flex align-items-center gap-2">
    <p-checkbox
      [formControl]="showAllProductsControl"
      [binary]="true"
      inputId="showAllProductsPicker"
      (onChange)="onShowAllProductsChange()"></p-checkbox>
    <label
      for="showAllProductsPicker"
      class="cursor-pointer"
      >Mostra anche prodotti fuori commessa</label
    >
  </div>
</div>
<div class="tbl max-w-full">
  <p-table
    [value]="products"
    dataKey="id"
    [paginator]="true"
    #dt1
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="rowsPerPageOptions"
    [lazy]="true"
    [loading]="loading"
    (onLazyLoad)="loadProducts($event)"
    [totalRecords]="totalRecords"
    [(selection)]="selectedProduct"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Risultati {first} - {last} di {totalRecords} totali">
    <ng-template pTemplate="header">
      <tr>
        <th></th>
        <th pSortableColumn="name">
          <div class="flex flex-row align-items-center gap-2">Nome <p-sortIcon field="name" /></div>
        </th>
        <th pSortableColumn="brand">
          <div class="flex flex-row align-items-center gap-2">
            Brand <p-sortIcon field="brand" />
          </div>
        </th>
        <th pSortableColumn="related_product_category.name">
          <div class="flex flex-row align-items-center gap-2">
            Categoria <p-sortIcon field="related_product_category.name" />
          </div>
        </th>
        <th pSortableColumn="code_internal">
          <div class="flex flex-row align-items-center gap-2">
            Codice interno <p-sortIcon field="code_internal" />
          </div>
        </th>
        <th pSortableColumn="code_supplier">
          <div class="flex flex-row align-items-center gap-2">
            Codice fornitore <p-sortIcon field="code_supplier" />
          </div>
        </th>
        <th pSortableColumn="desc_short">
          <div class="flex flex-row align-items-center gap-2">
            Descrizione <p-sortIcon field="desc_short" />
          </div>
        </th>
        <!-- <th></th> -->
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-p>
      <tr [ngClass]="{ 'disabled': checkIfProdIsChosen(p) }">
        <td *ngIf="pickerType !== 'radio'">
          <p-tableCheckbox [value]="p"></p-tableCheckbox>
        </td>
        <td *ngIf="pickerType === 'radio'">
          <p-radioButton
            [value]="p"
            [inputId]="p.id"
            name="selectedProductControl"
            [formControl]="selectedProductControl"></p-radioButton>
        </td>
        <td>
          {{ p.name || '-' }}
        </td>
        <td>
          {{ p.brand || '-' }}
        </td>
        <td>
          <p-chip>{{ p.related_product_category?.name || '-' }}</p-chip>
        </td>
        <td>
          <small>
            {{ p.code_internal || '-' }}
          </small>
        </td>
        <td>
          <small>
            {{ p.code_supplier || '-' }}
          </small>
        </td>
        <td>
          <small>
            {{ p.desc_short || '-' }}
          </small>
        </td>
      </tr>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td
            colspan="7"
            class="text-center py-2">
            Nessun risultato.
          </td>
        </tr>
      </ng-template>
    </ng-template>
  </p-table>
</div>

<div class="modal-footer">
  <div class="flex justify-content-between">
    <p-button
      (onClick)="close()"
      icon="pi pi-times"
      [text]="true"
      styleClass="butt red"
      [rounded]="true"></p-button>
    <p-button
      icon="pi pi-check"
      (onClick)="save()"
      styleClass="butt"
      [rounded]="true"></p-button>
  </div>
</div>
